import React, { useEffect } from 'react';
import FormSettingHarga from './FormSettingHarga';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBaseGeneralPrices, submitProductPrices } from './actions';

export default function Form() {
  const dispatch = useDispatch();
  const {
    dataBaseGeneralPrices
  } = useSelector((s) => s.prices);
  useEffect(() => {
    dispatch(fetchBaseGeneralPrices());
  }, []);

  return (
    <FormSettingHarga
      onSubmit={(values) => dispatch(submitProductPrices(values))}
      productGeneralMaxPrice={dataBaseGeneralPrices?.productGeneralMaxPrice}
      productGeneralMinPrice={dataBaseGeneralPrices?.productGeneralMinPrice}
    />
  );
}
